module.exports = __webpack_public_path__ + "static/media/bgcontact.c1cc91c8.png";